/**
 * Created by slava on 24.03.17.
 */

const CanUpgradeHeroWindow = CleverappsWindow.extend({
    onWindowLoaded: function () { 
        const styles = cleverapps.styles.CanUpgradeHeroWindow;

        const heroes = new cc.Node();
        heroes.setAnchorPoint(0.5, 0.5);
        heroes.setContentSize2(styles.heroesNode.width, styles.heroesNode.height);
        cleverapps.styles.HeroesScene.heroBuildings.forEach((building, order) => {
            const color = building.color.toUpperCase();

            const animation = new cleverapps.Spine(cleverapps.skins.getSlot(`${color}_hero_spine_json`) || bundles.heroes.jsons[`${color}_hero_spine_json`]);
            animation.setScale(styles.heroes[order].scale || 1.0);
            animation.setSkin(match3.heroes.getCurrentSkin());
            animation.setPosition(heroes.width / 2 + styles.heroes[order].x, heroes.height / 2 + styles.heroes[order].y);
            animation.setAnimation(0, "idle", true);
            heroes.addChild(animation);
        }, this);

        // eslint-disable-next-line no-restricted-syntax
        const text = cleverapps.UI.generateTTFText(Messages.get("CanUpgradeHeroes.Text"), cleverapps.styles.FONTS.WINDOW_TEXT);
        text.setDimensions(styles.heroesNode.width, 0);
        text.setHorizontalAlignment(cc.TEXT_ALIGNMENT_CENTER);

        const content = new cleverapps.Layout([heroes, text], {
            margin: styles.margin,
            direction: cleverapps.UI.VERTICAL
        });

        this._super({
            title: Messages.get("CanUpgradeHeroes.Title"),
            name: "canupgradeherowindow",
            content,
            button: {
                text: Messages.get("CanUpgradeHeroes.Button"),
                onPressed: function () {
                    cleverapps.focusManager.distract({
                        focus: "CanUpgradeHeroesScene",
                        action: function (f) {
                            cleverapps.scenes.replaceScene(bundles.main.jsons.heroesscene_prefab_json, f);
                        }
                    });
                },
                width: styles.button.width,
                height: styles.button.height
            }
        });
    },

    listBundles: function () {
        return ["can_upgrade_hero_window"];
    }
});

cleverapps.styles.CanUpgradeHeroWindow = {
    margin: 0,

    button: {
        width: 340,
        height: 90
    },

    heroesNode: {
        width: 550,
        height: 400
    },

    heroes: [{
        x: -56,
        y: 150,
        scale: 1
    }, {
        x: 56,
        y: 150,
        scale: 1
    }, {
        x: -150,
        y: 30,
        scale: 1.25
    }, {
        x: 150,
        y: 30,
        scale: 1.25
    }, {
        x: -80,
        y: -90,
        scale: 1.4
    }, {
        x: 80,
        y: -90,
        scale: 1.4
    }]
};